<div [class]="pillClasses()">
  <div
    class="flex flex-col items-start justify-start h-fit w-fit pl-0 pr-0 pt-0 pb-0 flex-nowrap"
  >
    @if (text()) {
    <span
      class="text-xs font-bold tracking-[1.2000000476837158px] leading-4 uppercase text-left h-fit w-fit flex-nowrap text-black"
      >{{ text() }}</span
    >
    }
  </div>
</div>
